module.exports = __webpack_public_path__ + "95377e3a404385f477f2d3a8a6d8ec92.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/flower-tulip.png
// module id = 2387
// module chunks = 0